import Cookies from 'js-cookie';
import { transferCookie } from './cookie';
import * as Logger from '../../common/tools/logger';
import {
  CONFIG_IAB_TCF_COOKIE_IDENTIFIER
} from '../../config';
import { BRAND_DOMAIN } from '../../common/tools/util';

/**
 * Update the `tcString` for the initialized TCF API (if available)
 * @param {string} tcString TCString to be updated within the cookie
 */
export const updateTCString = (tcString: string): void => {
  if (typeof window.__tcfapi !== 'function') {
    Logger.error(`TCF`, `updateTCString`, `Could not update TCString in 'window.__tcfapi', tcfapi is not available.`);
    return;
  }

  try {
    window.__tcfapi('updateTCString', 2, (success: boolean) => {
      if (!success) {
        Logger.error(`TCF`, `updateTCString`, `Updating the TCString in 'window.__tcfapi' failed, returned '${success}'.`);
      }
    }, tcString);
  } catch (error) {
    Logger.error(`TCF`, `updateTCString`, `Failed to update TCString in 'window.__tcfapi'.`, error);
  }
}

/**
 * Write the `tcString` to the PPP delivered domain
 * @param {string} tcString TCString to be written within the cookie
 */
export const setTCString = async(tcString: string): Promise<void> => {
  Cookies.set(CONFIG_IAB_TCF_COOKIE_IDENTIFIER, tcString, {
    domain: BRAND_DOMAIN,
    path: '/',
    expires: 390,
    secure: window.location.protocol === 'https:' ? true : false,
    sameSite: 'none'
  });
  updateTCString(tcString);
  await transferCookie(CONFIG_IAB_TCF_COOKIE_IDENTIFIER, tcString, 390);
}

/**
 * Get the `tcString` from the PPP delivered domains cookie
 */
export const getTCString = (): string => {
  return Cookies.get(CONFIG_IAB_TCF_COOKIE_IDENTIFIER) || '';
}
